import * as z from 'zod';

import { validationMessagesMap } from 'src/utils/messages';

export type UpdateCurrentUserFormSchemaValues = z.infer<typeof updateCurrentUserFormSchema>;
export const updateCurrentUserFormSchema = z.object({
    name: z.string().nonempty({ message: validationMessagesMap.validationErrorRequired }),
    email: z.email({ message: validationMessagesMap.validationErrorEmail }),
});

export type ChangeCurrentUserPasswordFormSchemaValues = z.infer<typeof changeCurrentUserPasswordFormSchema>;
export const changeCurrentUserPasswordFormSchema = z
    .object({
        password: z
            .string()
            .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_-])[a-zA-Z\d@$!%*?&_-]{8,}$/, {
                message: validationMessagesMap.validationErrorPassword,
            }),
        password_confirm: z.string().nonempty({ message: validationMessagesMap.validationErrorRequired }),
    })
    .superRefine(({ password, password_confirm }, ctx) => {
        if (password !== password_confirm) {
            ctx.addIssue({
                path: ['password_confirm'],
                code: 'custom',
                message: validationMessagesMap.validationErrorConfirmPassword,
            });
        }
    });

export type LangFormSchemaValues = z.infer<typeof langFormSchema>;
export const langFormSchema = z.object({
    lang: z.string().nonempty(),
});
